module.exports = __webpack_public_path__ + "img/newspaper-outline.1f46db94.svg";